module.exports = __webpack_public_path__ + "assets/img/img_no_order@2x.2ba22197.png";